export default __webpack_public_path__ + "static/media/023-stretcher.3cc2b4e7.png";